import { Order } from "../../types/order";

export default function PayType({ order }: { order: Order }) {
  if (!order) return null;
  if (!order.activePaymentSession) return null;

  return <span className="block max-w-[150px] truncate">{order.activePaymentSession.paymentName}</span>;
}
